<div class="confirm-dialog">
  <h3 class="confirm-title">{{ data.title }}</h3>
  <p class="confirm-message">{{ data.message }}</p>
  <div class="confirm-actions">
    <button class="btn-cancel" (click)="cancel()">{{ data.cancelLabel || 'Cancel' }}</button>
    <button class="btn-confirm" (click)="confirm()">{{ data.confirmLabel || 'Confirm' }}</button>
  </div>
</div>
